import styled from "@emotion/styled";

export const Styled = styled.div`
  .ant-pagination-item {
    border: 1px solid #000 !important;
  }
  .ant-pagination-next {
    border: 1px solid #000 !important;
    width: 32px;
  }
  .ant-pagination-prev {
    border: 1px solid #000 !important;
    width: 32px;
  }
  .ant-pagination-item-link {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
`;
